export enum DeclarationsRoute {
  empty = '',
  vatDeclarations = 'vat-declarations',
  taxReport = 'tax-report',
  capitalIncomeDeclaration = 'capital-income-declaration',
  otherDeclarations = 'other-declarations'
}
